"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.object.keys.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es7.object.get-own-property-descriptors.js");

require("core-js/modules/es6.object.assign.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RepeaterGroup = _interopRequireDefault(require("./RepeaterGroup"));

var _utils = require("../../../lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

require('../../../sass/components/shared/repeater/Repeater.css');

var plusIconSrc = require('../../../images/plus.svg');

var plusIcon = /*#__PURE__*/_react.default.createElement("div", {
  className: "plus-icon"
}, /*#__PURE__*/_react.default.createElement("img", {
  src: plusIconSrc
}));

var Repeater = /*#__PURE__*/function (_React$Component) {
  _inherits(Repeater, _React$Component);

  var _super = _createSuper(Repeater);

  function Repeater(props) {
    var _this;

    _classCallCheck(this, Repeater);

    _this = _super.call(this, props);
    _this.state = {
      allShut: props.startShut
    };
    _this.addRow = _this.addRow.bind(_assertThisInitialized(_this));
    _this.setAllShut = _this.setAllShut.bind(_assertThisInitialized(_this));
    _this.setActiveIdx = _this.setActiveIdx.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Repeater, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        fns: this.props.fns
      };
    }
  }, {
    key: "addRow",
    value: function addRow(e) {
      var _this$props = this.props,
          addRowAndIncrement = _this$props.addRowAndIncrement,
          analyticsObject = _this$props.analyticsObject;
      this.setState({
        allShut: false
      });
      addRowAndIncrement(e);
      analyticsObject && analyticsObject.addnew && (0, _utils.googleAnalytics)(analyticsObject.addnew)();
    }
  }, {
    key: "setAllShut",
    value: function setAllShut() {
      this.setState({
        allShut: true
      });
    }
  }, {
    key: "setActiveIdx",
    value: function setActiveIdx(activeIdx) {
      var _this$props2 = this.props,
          validatePage = _this$props2.validatePage,
          setRowIdx = _this$props2.setRowIdx,
          oldActiveIdx = _this$props2.activeIdx;

      if (!this.state.allShut && isFinite(activeIdx)) {
        if (!validatePage(oldActiveIdx)) {
          return;
        }
      }

      this.setState({
        allShut: false
      }, function () {
        setRowIdx(activeIdx);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props,
          state = this.state,
          addRow = this.addRow,
          setAllShut = this.setAllShut,
          setActiveIdx = this.setActiveIdx;

      var children = props.children,
          rows = props.rows,
          activeIdx = props.activeIdx,
          addLabel = props.addLabel,
          rest = _objectWithoutProperties(props, ["children", "rows", "activeIdx", "addLabel"]); // TODO: inline styles :-/


      return /*#__PURE__*/_react.default.createElement("div", {
        className: "repeater-container"
      }, rows.map(function (row, idx) {
        return /*#__PURE__*/_react.default.createElement(_RepeaterGroup.default, _extends({
          key: idx,
          rowsLen: rows.length,
          isActive: !state.allShut && activeIdx === idx
        }, _objectSpread({
          idx: idx,
          row: row,
          setActiveIdx: setActiveIdx,
          setAllShut: setAllShut
        }, rest)), children);
      }), /*#__PURE__*/_react.default.createElement("button", {
        className: "repeater-add",
        label: addLabel,
        onClick: addRow,
        onKeyDown: _utils.preventTabKeyPress
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "repeater-add-flex-wrapper"
      }, plusIcon, addLabel)));
    }
  }]);

  return Repeater;
}(_react.default.Component);

exports.default = Repeater;
Repeater.childContextTypes = {
  fns: _propTypes.default.objectOf(_propTypes.default.func)
};
Repeater.propTypes = {
  rows: _propTypes.default.array.isRequired,
  addLabel: _propTypes.default.string,
  activeIdx: _propTypes.default.number,
  setRowIdx: _propTypes.default.func.isRequired,
  validatePage: _propTypes.default.func.isRequired,
  addRowAndIncrement: _propTypes.default.func.isRequired,
  analyticsObject: _propTypes.default.shape({
    addnew: _propTypes.default.string,
    close: _propTypes.default.string,
    view: _propTypes.default.string
  }),
  startShut: _propTypes.default.bool
};
Repeater.defaultProps = {
  addLabel: 'Add',
  startShut: false
};